<template>
 <Dialog
      title="更多语言"
      tips="请按“原发语言”填写，然后点击「翻译」按钮即可，如需更换“原发语言”可在系统设置页面修改默认语言，刷新后台即完成更改。"
      width="640"
      height="760"
      :isMask="false"
      :loading="translationDialogLoading"
      :visible.sync="isTranslationDialog"
      @on-Confirm="onConfirmTranslation"
    >
      <template slot="form">
        <div class="translation_box">
            <div class="form-item">
              <span class="lable">原发语言 {{sourceLanguage}}：</span>
              <div class="group">
                  <div class="flex yjui-input-block">
                   <textarea  class="yjui-textarea  wv100"  placeholder="请输入翻译文本" v-model="localTranslationTitle" rows=1></textarea>
                  </div>
                  <Button class="translation_btn" type="reset" :loading="translationLoading" @click="translationPost()">翻译</Button>
              </div>
            </div>
            <h2 class="title">其它语言</h2>
            <div class="form-item" v-for="(item,index) in languagepack">
              <span class="lable">{{item.nativeName}}：</span>
              <div class="group">
                  <div class="flex yjui-input-block">
                    <textarea class="yjui-textarea  wv100"  placeholder="请输入翻译文本"   v-model="item.text" rows=1></textarea>
                  </div>
              </div>
            </div>
          
        </div>
      </template>
    </Dialog>
</template>
<script>
    export default {
        name: 'Translation',
          data () {
            return {
                translationLoading:false,
                translationDialogLoading:false,
                isTranslationDialog:true,
                localTranslationTitle: this.translationTitle
            }
          },
        props: {
            languagepack: {//语言包
                  type: Array,
                  default: []
            },
            translationTitle: {//翻译内容
                type: String,
                default: ''
            },
            sourceLanguage: {//原发语言
                  type: String,
                  default: 'default'
            },
            onOk:{
                type:Function
            },
        },
        computed: {
         
        },
        methods: {
            //调用翻译接口翻译
            translationPost:function(){
                if(this.translationLoading==true) return;
                this.translationLoading=true;
                    this.http.post("api/SysGlobalization/Translation", {text:this.localTranslationTitle}).then(res => {
                    if (res.code == 200) {
                        //语言包添加上翻译好的文本
                        this.languagepack.map((item, index) => {
                            let finditem=res.data.find(p=> p.targetLanguage==item.language);
                            if(finditem){
                                return Object.assign(item, { text: finditem.translation });
                            }
                        })
                    } else {
                        this.$Message.error(res.errorMsg);
                    }
                    this.translationLoading=false;
                }).catch((error) => {
                    this.translationLoading=false;
                    this.$Message.error(error);
                });
            },
             //翻译确定事件
            onConfirmTranslation:function(){
                const title =this.localTranslationTitle
                const translationData = this.languagepack.map(item => ({ languageId: item.language, text: item.text }));

                this.onOk({title,translationData})
                this.isTranslationDialog=false;
            },
        }
    };
</script>

<style scoped>

.translation_box{padding-right: 20px;}
.translation_box .title{font-size: 18px;margin-top: 15px; }
    .translation_box .form-item{ margin-top: 15px;}
    
    .translation_box .form-item .lable{font-size: 14px; }
    .translation_box .form-item .group{ display: flex; place-items: center;margin-top: 10px;} 
    .translation_box .form-item .group .translation_btn{ margin-left: 15px;}
.yjui-textarea{min-height:38px;}
</style>




// WEBPACK FOOTER //
// src/components/Translation/translation.vue